import {
  Box,
  Button,
  Card,
  CardContent,
  Grid,
  Stack,
  Typography,
} from '@mui/material';
import {
  GppGood,
  Lock,
  Insights,
  History,
  Gavel,
  VerifiedUser,
  WhatsApp,
} from '@mui/icons-material';

const WHATSAPP_NUMBER = '5519998449211';
const WHATSAPP_MESSAGE =
  'Olá, tenho interesse em ativar o EezyLine para minha empresa. Gostaria de receber mais informações.';

const BENEFITS = [
  {
    icon: <Lock color="primary" />,
    title: 'Proteção do denunciante',
    text: 'Canal seguro com anonimato garantido de ponta a ponta.',
  },
  {
    icon: <Insights color="primary" />,
    title: 'Gestão centralizada',
    text: 'Todas as ocorrências organizadas, com prioridade e responsável.',
  },
  {
    icon: <VerifiedUser color="primary" />,
    title: 'Evidências protegidas',
    text: 'Armazenamento privado e acesso controlado por links temporários.',
  },
  {
    icon: <History color="primary" />,
    title: 'Histórico e rastreabilidade',
    text: 'Cada alteração registrada em uma timeline completa.',
  },
  {
    icon: <Insights color="primary" />,
    title: 'Indicadores e relatórios',
    text: 'Dashboards e exportações para acompanhar a evolução.',
  },
  {
    icon: <Gavel color="primary" />,
    title: 'Apoio à conformidade',
    text: 'Auxilia na organização e boas práticas relacionadas à LGPD e à legislação trabalhista.',
  },
];

export default function EezyGuardLanding(): JSX.Element {
  const whatsappUrl = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(
    WHATSAPP_MESSAGE
  )}`;

  return (
    <Box display="flex" flexDirection="column" gap={3}>
      <Stack alignItems="center" spacing={1} textAlign="center">
        <GppGood color="primary" sx={{ fontSize: 56 }} />
        <Typography variant="h4" fontWeight={700}>
          EezyLine
        </Typography>
        <Typography color="text.secondary" maxWidth={640}>
          Um canal de denúncias corporativas seguro e confidencial. Receba, avalie e
          trate ocorrências de assédio, discriminação, fraude e outras condutas — com
          proteção total ao denunciante.
        </Typography>
      </Stack>

      <Grid container spacing={2}>
        {BENEFITS.map((b) => (
          <Grid key={b.title} item xs={12} sm={6} md={4}>
            <Card variant="outlined" sx={{ height: '100%' }}>
              <CardContent>
                <Stack spacing={1}>
                  {b.icon}
                  <Typography variant="subtitle1" fontWeight={600}>
                    {b.title}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {b.text}
                  </Typography>
                </Stack>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>

      <Card
        variant="outlined"
        sx={{ textAlign: 'center', bgcolor: 'action.hover', py: 2 }}
      >
        <CardContent>
          <Typography variant="h6" gutterBottom>
            Ative o EezyLine para sua empresa
          </Typography>
          <Typography variant="body2" color="text.secondary" mb={2}>
            O sistema auxilia na organização, rastreabilidade e conformidade. Não
            promete conformidade jurídica automática nem substitui assessoria jurídica.
          </Typography>
          <Button
            variant="contained"
            size="large"
            color="success"
            startIcon={<WhatsApp />}
            component="a"
            href={whatsappUrl}
            target="_blank"
            rel="noreferrer"
          >
            Falar com um especialista
          </Button>
        </CardContent>
      </Card>
    </Box>
  );
}
